import { useLabelVersion } from '../../../../features/labels/LabelsProvider';
import { labelId } from '../../../../features/labels/labels';
import React, { useState, useEffect, useRef } from 'react';
// import { Grid,Tooltip } from '@mui/material';
import { Button, IconButton, Grid, Tooltip, Dialog, DialogActions, DialogTitle ,DialogContent, FormControlLabel, LinearProgress, Box} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

import {
  // Charts
  BarChartPPAandNV,
  BarChartSemanal,
  BarChartTONandA,
  DoughnutChart,
  SfrChart,
  TasaChart,
  // Ranking
  Ranking,
} from '../../Components/Charts'
import '../../Components/Charts/styles/Dashboard.css';
import { exportSummaryPDF } from '../../Components/utils/exportSummaryPDF';
import ScappSwitch from '../../Components/utils/ScappSwitch';
import { canViewAlarmReaction } from '../../../../features/ai-usage/aiUsageClient';
import { buildNotesByJaulaDay } from '../../Components/Charts/LineChart/TasaChart';
    
const MenuAnalitica = ({ alarmGraph, setAlarmGraph, data, dias, setDias, jaulaSeleccionada, setJaulaSeleccionada, selectedDay, setSelectedDay, viewMode, fastingResolution, selectedRateKey, nivelSeleccionado, compact, translate}) => {
  useLabelVersion();
  const t = (key, fallback, params) => {
    const value = typeof translate === 'function' ? translate(key, params) : key;
    return value && value !== key ? value : fallback;
  };

  //! Extraer siempre el mapa principal
  const dataMap = React.useMemo(() => data?.analytic_data ?? {}, [data?.analytic_data]);
  const notesByJaulaDay = React.useMemo(
    () => buildNotesByJaulaDay(data?.notes || [], dataMap, compact),
    [compact, data?.notes, dataMap],
  );
  //! Para vista “jaula”  
  const jaulas = Object.values(dataMap);
  //! Para vista “área”: todos los centros dentro de cada área
  const centros = Object.entries(dataMap ?? {})
  .flatMap(([areaKey, centersObj]) =>
    Object.entries(centersObj ?? {}).map(([centerKey, centerObj]) => ({
      name: centerKey.split('-').pop(),
      label: labelId(centerKey, 'rac', centerKey.split('-').pop()),
      values_summary: Object.entries(centerObj.values_summary ?? {}).map(
        ([day, summary]) => ({ day, value: summary })
      ),
      alarms_by_tasa: Object.entries(centerObj.tasa_summary ?? {}).map(
        ([day, tasa_summary]) => ({
          day,
          value: Object.fromEntries(
            Object.entries(tasa_summary).map(
              ([nivel, { alarm, tasas }]) => [
                nivel,
                { value: alarm, tasas }
              ]
            )
          )
        })
      )
    }))
  );
  const barResumenRef = useRef(null);
  const donutResumenRef = useRef(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [darkModePDF, setDarkModePDF] = useState(false); // o donde ya controles el modo
  const [loadingPDF, setLoadingPDF] = useState(false);  
  const [progressPDF, setProgressPDF] = useState(0);
  const handleOpenDialog = () => setDialogOpen(true);


  const handleExport = async () => {
    console.log('setLoadingPDF')
    try {
      // 1) estado de carga + deshabilitar botón externo
      setLoadingPDF(true);
      setProgressPDF(0);
      // 2) cerrar el modal de inmediato (lo pides explícitamente)
      setDialogOpen(false);

      // 4) lanzar export con onProgress que actualiza la barra
      await exportSummaryPDF({
        barChart: barResumenRef.current,
        donutChart: donutResumenRef.current,
        darkModePDF,
        fileName: 'Resumen_barras_y_dona.pdf',
        titles: {
          bar: t('summary', 'Resumen'),
          donut: t('alarm_rate', 'Alarmas por tasa'),
        },
        donutDetailSource: {
          jaulas,                // el mismo array que usa DoughnutChart
          jaulaSeleccionada,     // si corresponde (o null)
          selectedDay,           // si corresponde (o null, para acumulado)
          selectedRateKey,
        },
        onProgress: (pct) => setProgressPDF(Number.isFinite(pct) ? pct : 0),
      });
    } finally {
      // 5) restaurar estados
      setLoadingPDF(false);
      setProgressPDF(0);
    }
  };
 

  // Convertir JSON a array de jaulas y obtener los días comunes
  //? const jaulas = Object.values( data?.analytic_data ?? { values_summary: {} } );
  //! El array que finalmente pasamos a los charts
  const chartData = nivelSeleccionado === 'area' ? centros : jaulas;

  // Estilos para las tarjetas del dashboard
  const cardStyles = {
    small:   { display:'flex', justifyContent:'center', alignItems:'center', alignContent:'center', height: '24vh', padding: '0.5vw', marginLeft: '0.5vw' },
    large:   { display:'flex', justifyContent:'center', alignItems:'center', alignContent:'center', height: '32vh', padding: '0.5vw', marginLeft: '0.5vw' },
    ranking: { height: '89vh', width: '15.5vw', marginLeft: '0.5vw', overflow:'hidden' },
  };

  const styleCardComparar={ maxHeight:'23vh',minHeight:'23vh', width:'39.5vw' }
  const styleCardCompararArea={ maxHeight:'23vh',minHeight:'23vh', width:'80vw' }

  const chartProps = {
    chartData:chartData,
    cardStyles,
    Leyendas,
    styleCardComparar,
    jaulaSeleccionada,
    selectedDay,
    viewMode,
    selectedRateKey,
    nivelSeleccionado,
    styleCardCompararSFR: nivelSeleccionado === 'centro' ? styleCardComparar : styleCardCompararArea,
    InfoIconStyle: '0.5vw',
    SwapVertIconStyle:'-2.4vw',
    dias,
    titulo:`${nivelSeleccionado === 'centro' ? translate('cages') : translate('centers')}` ,
    alarmGraph,setAlarmGraph,
    marginRight:'1vw',
    marginLeft:'1vw',
    iconLeft:'1vw',
    translate,
    showAlarmReaction: canViewAlarmReaction(localStorage.getItem('cargo')),
    notesByJaulaDay,

  }
  const RankingProps = {
    width:"100%", 
    height:"100%", 
    numberOfYAxes:2, 
    titulo: nivelSeleccionado === 'centro' ? translate('ranking_of_cages') : translate('ranking_of_centers'),
    chartData: chartData, 
    viewMode,
    fastingResolution,
    jaulaSeleccionada, setJaulaSeleccionada, 
    selectedDay, setSelectedDay, 
    isVertical:true,
    label: nivelSeleccionado === 'centro' ? translate('cage_label') : translate('center_label'),
    todo: nivelSeleccionado === 'centro' ? translate('all_female') : translate('all_male'),
    nivelSeleccionado,
    translate
  }

  let NivelResumen 

  if (nivelSeleccionado === 'centro'){
    NivelResumen = translate('summary_by_cages')
  } else{
    NivelResumen = translate('summary_by_centers')
  }

  return (
    <Grid container justifyContent="center" alignItems={'center'} alignContent={'center'} style={{ cursor: 'default !important', userSelect: 'none', height: '100%', width: '100vw', marginLeft: '-0.6vw',}}>
      <Grid container justifyContent="flex-start" item xs={9.8} >
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="center" className='card' style={{ ...cardStyles.small, width: '99.1%', position:'relative' }}>
            <Grid item xs={8.5} style={{ height: '18vh', width: '100%', marginTop: '0vh', marginLeft: '-1vw', }}>
              <h2 className='h2' style={{marginLeft:'1vw', marginTop:'-1.5vh'}}>{NivelResumen}</h2>
              <div key={alarmGraph} style={{height:'18vh', width:'55vw', marginLeft:'0vw'}} >
                 <BarChartSemanal {...chartProps} chartInstanceRef={barResumenRef} loadingPDF={loadingPDF} setLoadingPDF={setLoadingPDF}/>
                 {/* //jaulas={jaulas} /> */}
              </div>
            </Grid>
            {loadingPDF && progressPDF > 0 && (
              <Box sx={{ width: '25%', mt: '-20vh',marginLeft:'-20vw', position:'absolute' }}>
                <LinearProgress
                  variant="determinate"
                  value={progressPDF}
                  // sx={{ height: 8, borderRadius: 2 }}
                  sx={{
                      height: '.8vh',
                      borderRadius: '.5vw',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: '#e94e1a',   // 👈 color de la barra
                      },
                      backgroundColor: 'rgba(233,78,26,0.2)' // 👈 opcional, color del fondo
                    }}
                />
                <p  sx={{ mt: '.25vh', textAlign: "center" }}>
                  {progressPDF}% {t('generating_pdf', 'Generando PDF...')}
                </p>
              </Box>
            )}
            {/* Grafico dona contenedor xs={3} */}
            <DoughnutChart {...chartProps} chartInstanceRef={donutResumenRef}/>
            <div style={{position:'absolute', top:'19vh', right:'1.5vw',}}>
              <IconButton variant="" onClick={handleOpenDialog}  >
                <DownloadIcon className='icon-m' style={{width:'1.3vw', aspectRatio:1}}/>
              </IconButton>
              {/* MODAL DE MODO OSCURO PARA PDF */}
              <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                PaperProps={{
                  sx: {
                    bgcolor: '#0c0c0c !important',
                    color: "#e6e6e6",
                    border: "0.01vw solid #e94e1a",
                    borderRadius: ".4vw",
                    minWidth: '15vw',
                    boxShadow: 'none',
                  },
                }}
                slotProps={{
                  backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0) !important" } },
                }}
                
              >
                <DialogTitle
                  sx={{
                    fontWeight: 700,
                    letterSpacing: 0.2,
                    borderBottom: "0.01vw solid #e94e1a",
                    pb: "1vh",
                    bgcolor: '#0c0c0c !important', 
                  }}
                >
                  {t('export_options', 'Opciones de exportación')}
                </DialogTitle>
        
                <DialogContent sx={{  display: "grid", gap: "1.2rem", bgcolor: '#0c0c0c !important',  }}>
                  <FormControlLabel
                    sx={{ ".MuiFormControlLabel-label": { color: "#cbd5e1", fontWeight: 500 }, gap: ".5vw", marginTop: "1vh", }}
                    control={
                      <ScappSwitch
                        isChecked={darkModePDF}
                        onToggle={(e, checked) => setDarkModePDF(typeof checked === "boolean" ? checked : e.target.checked)}
                        inputProps={{ "aria-label": t('dark_mode_pdf', 'Modo oscuro PDF') }}
                      />
                    }
                    label={t('dark_mode_pdf', 'Modo oscuro PDF')}
                  />
                </DialogContent>
        
                <DialogActions sx={{ borderTop: "1px solid #e84e0e", p: 2, gap: 1, bgcolor: '#0c0c0c !important',  }}>
                  <Button
                    onClick={() => setDialogOpen(false)}
                    sx={{ textTransform: "none", color: "#cbd5e1",bgcolor: "#0c0c0c !important", "&:hover": { bgcolor: "rgba(148,163,184,.08) !important" } }}
                  >
                    {t('cancel', 'Cancelar')}
                  </Button>
                  <Button variant="contained" onClick={handleExport}
                    sx={{ textTransform: "none", color: "#cbd5e1",bgcolor: "#0c0c0c !important", border:'solid 0.01vw #e84e0e', "&:hover": { bgcolor: "rgba(148,163,184,.08) !important" } }}
                  >
                    {t('generate_pdf', 'Generar PDF')}
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            {/* // jaulas={jaulas}  jaulaSeleccionada={jaulaSeleccionada}  selectedDay={selectedDay}/> */}
            {/* <Grid container justifyContent={'center'} alignContent={'center'} alignItems={'center'} item xs={2.5} height='23.7vh' borderLeft='solid 0.1vh #e94e1a'>
              <CalendarioAnalitica dias={dias} setDias={setDias}/>
            </Grid> */}
          </Grid>
        </Grid>
        {/* ALARMAS POR TONELADA / ALARMAS */}
        <BarChartTONandA {...chartProps}/> 
        {/* Pellet Perdido Acumulado / Número de Visita */}
        <BarChartPPAandNV {...chartProps}/> 
        {/* TASA */}
        {nivelSeleccionado === 'centro' && <TasaChart {...chartProps} compact={compact} />}
        {/* SFR */}
        <SfrChart {...chartProps} /> {/* <canvas ref={sfrValueChartRef} /> */}
      </Grid>

      <Grid item xs={2} >
        <div className='card' style={cardStyles.ranking}>
          <Ranking {...RankingProps} />
        </div>
      </Grid>


    </Grid>
  );
};
export default MenuAnalitica


const Leyendas = ({ data, toggle, visible, width ='29vw', translate }) => {
  const [legendItems, setLegendItems] = useState([])
  const t = (key, fallback) => {
    const value = typeof translate === 'function' ? translate(key) : key;
    return value && value !== key ? value : fallback;
  };

  useEffect(() => {
    const groups = Object?.values(
      data?.datasets?.reduce((acc, ds, idx) => {
        const key = ds.entityKey ?? ds.label;
        if (!acc[key]) acc[key] = { key, label: ds.label, backgroundColor: ds.backgroundColor, indices: [idx] }
        else acc[key].indices.push(idx)
        return acc
      }, {})
    );

    const items = groups?.map(group => {
      // a) ¿algún valor real?
      const hasRealData = group.indices.some(i =>
        Array.isArray(data.datasets[i].data) &&
        data.datasets[i].data.some(v => v != null && v !== 0)
      );
      // b) ¿algún cero pero sin datos reales?
      const zeroOnly = !hasRealData && group.indices.some(i =>
        Array.isArray(data.datasets[i].data) &&
        data.datasets[i].data.some(v => v === 0)
      );
      // c) true sólo si TODAS las series del grupo están visibles
      const isVisible = group?.indices.every(i => visible[i]);
      return { ...group, hasRealData, zeroOnly, isVisible };
    });

    items.sort((a, b) => {
      // primero los reales, luego los ceros, luego sin datos
      if (a.hasRealData !== b.hasRealData) return a.hasRealData ? -1 : 1;
      if (a.zeroOnly    !== b.zeroOnly)    return a.zeroOnly    ? -1 : 1;
      return 0;
    });

    setLegendItems(items);
  }, [data?.datasets, visible]);


  return (
    <div style={{ 
      display: 'flex', flexWrap: 'wrap',
      justifyContent: 'center', maxHeight: '5vh',
      minHeight: '5vh', width: width,
      overflowY: 'auto'
    }}>
      {legendItems.map(({ key, label, backgroundColor, indices, hasRealData, zeroOnly, isVisible }) => {
        const node = (
          <div
            key={key}
            onClick={() => hasRealData && indices.forEach(i => toggle(i))}
            style={{
              position: 'relative',
              display: 'flex', alignItems: 'center',
              height: '2vh', marginRight: '0.4vw',
              cursor: hasRealData ? 'pointer' : 'default',
              opacity:(hasRealData || zeroOnly) ? 1 : 0.5,
            }}
          >
            <div style={{ backgroundColor, width: '1vw', height: '0.4vw', marginRight: '0.1vw' }}/>
            <p style={{ textDecoration: hasRealData && isVisible ? 'none' : 'line-through', color: '#777', fontSize: '0.6vw' }}>
              {label}
            </p>
          </div>
        );

        // Tooltip según el caso
        if (hasRealData) {
          return node;
        } else if (zeroOnly) {
          return <Tooltip key={key} title={t('zero_value', 'Valor 0')}>{node}</Tooltip>;
        } else {
          return <Tooltip key={key} title={t('no_data', 'No hay datos')}>{node}</Tooltip>;
        }
      })}
    </div>
  )
}
